import { useEffect, useState } from "react";
import axios from "axios";
import { FileText, ExternalLink, ImageOff } from "lucide-react";
import { API } from "../lib/api";

const AttachmentItem = ({ trxId, kind, label, meta, index }) => {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let blobUrl = "";
    setUrl(""); setFailed(false);
    axios.get(`${API}/transactions/${trxId}/attachments/${kind}/${index}`, { responseType: "blob" })
      .then(r => { blobUrl = URL.createObjectURL(r.data); setUrl(blobUrl); })
      .catch(() => setFailed(true));
    return () => blobUrl && URL.revokeObjectURL(blobUrl);
  }, [trxId, kind, meta, index]);
  const isPdf = meta?.content_type === "application/pdf";
  return <div className="attach-preview-item" data-testid={`preview-${kind}-${index}`}>
    {failed ? <div className="attach-empty">Gagal memuat lampiran</div> : !url ? <div className="attach-empty">Memuat...</div> : isPdf ? <div className="attach-empty"><FileText size={20} /> {meta.filename}</div> : <a className="watermarked-photo" href={url} target="_blank" rel="noreferrer"><img src={url} alt={label} />{meta.watermark_at && !meta.watermarked && <span>{meta.watermark_at}</span>}</a>}
    {meta.watermark_at && <small className="muted">{meta.watermark_at}</small>}
    {url && <a className="text-link" data-testid={`open-${kind}-${index}`} href={url} target="_blank" rel="noreferrer"><ExternalLink size={13} /> Buka {isPdf ? "PDF" : "ukuran penuh"}</a>}
  </div>;
};

export const AttachmentPreview = ({ trxId, kind, label, meta }) => {
  const attachments = !meta ? [] : Array.isArray(meta) ? meta : [meta];
  return <div className="attach-preview" data-testid={`preview-${kind}`}><span className="eyebrow">{label} · {attachments.length} lampiran</span>{attachments.length ? <div className="attachment-preview-list">{attachments.map((item,index)=><AttachmentItem key={`${item.filename}-${index}`} trxId={trxId} kind={kind} label={label} meta={item} index={index} />)}</div> : <div className="attach-empty"><ImageOff size={20} /> Tidak ada lampiran</div>}</div>;
};
